import { render, staticRenderFns } from "./BackgroundCircle.vue?vue&type=template&id=acd79e32"
import script from "./BackgroundCircle.vue?vue&type=script&lang=js"
export * from "./BackgroundCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports